import { useStore } from 'reactflow';

/** Mesma lógica do toggle de interatividade do React Flow (Controls). */
export function useDiagramInteractive(): boolean {
  return useStore((s) => s.nodesDraggable || s.nodesConnectable || s.elementsSelectable);
}
